var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpikeShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spikeShapes"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,300 1620,400 0,400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1920,800 620,900 1920,850 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,1300 1020,1350 0,1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1920,1500 320,1600 1920,1610 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1920,2000 1000,2040 1920,2050"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,2000 1420,2150 0,2100"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,2500 1020,2540 0,2550"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,2850 1220,2910 0,2940"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1900,3150 600,3240 1920,3250"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1900,3600 300,3650 1920,3710"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,4090 1220,4140 0,4200"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1900,4600 300,4650 1920,4570"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeShapes);
export default __webpack_public_path__ + "static/media/SpikeShapes.74d12739e69dbefbd7f58a5fad07dac8.svg";
export { ForwardRef as ReactComponent };